import { render } from "./HotDog.vue?vue&type=template&id=2888bfb4"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/HotDog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2888bfb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2888bfb4', __exports__)) {
    api.reload('2888bfb4', __exports__)
  }
  
  module.hot.accept("./HotDog.vue?vue&type=template&id=2888bfb4", () => {
    api.rerender('2888bfb4', render)
  })

}


export default __exports__